var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_439_667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4438 12.2245C23.4438 11.2413 23.364 10.5238 23.1913 9.77966H11.9634V14.2176H18.5539C18.4211 15.3205 17.7036 16.9815 16.1091 18.0976L16.0867 18.2462L19.6368 20.9964L19.8827 21.0209C22.1416 18.9347 23.4438 15.8653 23.4438 12.2245Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9635 23.9176C15.1923 23.9176 17.9029 22.8545 19.8828 21.0209L16.1092 18.0976C15.0993 18.8018 13.744 19.2934 11.9635 19.2934C8.80107 19.2934 6.11701 17.2074 5.16021 14.324L5.01997 14.3359L1.32855 17.1927L1.28027 17.3269C3.24681 21.2334 7.28623 23.9176 11.9635 23.9176Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16039 14.3239C4.90794 13.5798 4.76183 12.7825 4.76183 11.9587C4.76183 11.1349 4.90794 10.3376 5.14711 9.59354L5.14042 9.43507L1.40275 6.53235L1.28046 6.59052C0.469952 8.21162 0.00488281 10.032 0.00488281 11.9587C0.00488281 13.8854 0.469952 15.7058 1.28046 17.3269L5.16039 14.3239Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9635 4.62403C14.209 4.62403 15.7238 5.59402 16.5875 6.40461L19.9625 3.10928C17.8897 1.1826 15.1923 0 11.9635 0C7.28623 0 3.24681 2.68406 1.28027 6.59056L5.14693 9.59359C6.11701 6.7102 8.80107 4.62403 11.9635 4.62403Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.104e75dc4a4ee39ceada37b3c95fb4d2.svg";
export { ForwardRef as ReactComponent };